import React from 'react';
import { PlayCircleIcon } from 'lucide-react';
export function VideoSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 md:py-20 lg:py-24 px-4" data-id="element-259">
      <div className="max-w-5xl mx-auto" data-id="element-260">
        <div className="bg-[#1a1a1a] p-12 md:p-16 rounded-lg border-4 border-gray-700 shadow-lg" data-id="element-261">
          <div className="flex justify-center mb-10" data-id="element-262">
            <PlayCircleIcon className="w-24 h-24 text-[#c41e3a]" aria-hidden="true" data-id="element-263" />
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-white mb-10 text-center leading-tight" data-id="element-264">
            Material <span className="text-[#c41e3a]" data-id="element-265">audiovisual</span> de
            apoyo incluido
          </h2>
          <div className="w-24 h-1 bg-[#c41e3a] mx-auto mb-10" data-id="element-266"></div>
          <p className="text-2xl md:text-3xl text-gray-300 leading-relaxed text-center mb-8" data-id="element-267">
            Además de los ebooks profesionales, la formación incluye{' '}
            <span className="text-white font-bold" data-id="element-268">videos complementarios</span>{' '}
            para reforzar técnicas y ver su aplicación práctica en tiempo real.
          </p>
          <p className="text-2xl md:text-3xl text-gray-200 font-black text-center mb-10" data-id="element-269">
            Los videos no reemplazan el método escrito: lo acompañan, lo
            refuerzan y te muestran las técnicas en acción.
          </p>
          <div className="bg-[#0a0a0a] border-4 border-[#c41e3a] rounded-lg p-8 max-w-3xl mx-auto" data-id="element-270">
            <p className="text-gray-300 text-xl text-center leading-relaxed" data-id="element-271">
              📚{' '}
              <span className="font-bold text-white" data-id="element-272">
                Ebooks para estudiar y consultar
              </span>{' '}
              + 🎥{' '}
              <span className="font-bold text-white" data-id="element-273">
                Videos para ver técnicas aplicadas
              </span>{' '}
              = Formación completa y profesional
            </p>
          </div>
        </div>
      </div>
    </section>;
}